<template>
  <div id="sms-success-container">
    <MarkdownCopy :content="$t.programAcceptText" />
    <MarkdownCopy :content="$t.generalAcceptText" />
  </div>
</template>

<script setup>
import '@garmin/components-global-web/dist-web/components/GCopy';
import MarkdownCopy from './MarkdownCopy.vue';

defineOptions({
  name: 'SmsSuccess',
});
</script>
